module.exports = __webpack_public_path__ + "img/type-orange.633ea025.png";